<template>
  <component :is="size" :class="styleSize || size">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: true,
      validator: (v) => ['h1', 'h2', 'h3', 'h4', 'h5'].indexOf(v) !== -1,
    },
    styleSize: {
      type: String,
      required: false,
      validator: (v) => ['h1', 'h2', 'h3', 'h4', 'h5'].indexOf(v) !== -1,
    },
  },
};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  line-height: 1.5;

  &.h1 {
    font-size: 28px;
  }

  &.h2 {
    font-size: 24px;
  }

  &.h3 {
    font-size: 21px;
  }

  &.h4 {
    font-size: 18px;
  }

  &.h5 {
    font-size: 16px;
  }
}
</style>
